<template>
  <div>
    <v-menu transition="slide-x-transition" bottom right>
      <template v-slot:activator="{on, attrs}">
        <div v-bind="attrs" v-on="on">
          <v-icon color="#222222" class="icon-mapit notranslatable" :data-cy="`menu-${item.id}`">)</v-icon>
        </div>
      </template>

      <v-list dense class="list-menu-actions">
        <v-list-item @click="viewLead(item.id)">
          <v-list-item-title>
            {{ $t('leads.list.actions.view') }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item :disabled="!!item.offerId || item.status === LeadStatus.Lost" @click="createOffer(item)">
          <v-list-item-title>
            {{ $t('leads.list.actions.create-offer') }}
          </v-list-item-title>
        </v-list-item>
        <v-divider />
        <v-list-item :disabled="!item.read || item.status !== LeadStatus.New" @click="markLeadAsRead(item, false)">
          <v-list-item-title>
            {{ $t('leads.list.actions.mark-unread') }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item :disabled="item.status === LeadStatus.Lost" @click="openConfirmDialog(item)">
          <v-list-item-title>
            {{ $t('leads.list.actions.mark-lost') }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <mapit-dialog :dialog="dialog" @close="closeConfirmDialog" customId="popup-confirm-lost-lead">
      <template v-slot:header-icon>
        <v-icon class="text-orange">fa-solid fa-hexagon-exclamation</v-icon>
      </template>
      <template v-slot:header-text>
        <div class="text-center">{{ $t('leads.list.confirm-lost-popup.title') }}</div>
      </template>
      <template v-slot:body>
        <div class="text-center">
          <div v-html="$t('leads.list.confirm-lost-popup.body')" />
        </div>
      </template>
      <template v-slot:footer-center>
        <v-btn data-cy="btn-cancel-lost-lead" class="btn-gray" @click="closeConfirmDialog">
          {{ $t('buttons.cancel') }}
        </v-btn>
        <v-btn data-cy="btn-confirm-lost-lead" class="btn-primary" @click="confirmLostLead" :loading="loading">
          {{ $t('buttons.confirm') }}
        </v-btn>
      </template>
    </mapit-dialog>
  </div>
</template>
<script lang="ts">
import {defineComponent, PropType, ref} from '@vue/composition-api'

import MapitDialog from '@/components/dialog/MapitDialog.vue'
import {LeadStatus, LeadSummary} from '@/types'

export default defineComponent({
  name: 'LeadsTableActions',
  components: {MapitDialog},
  props: {
    item: {
      type: Object as PropType<LeadSummary>,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    markLeadAsRead: {
      type: Function as PropType<(lead: LeadSummary, read: boolean) => Promise<void>>,
      required: true,
    },
    maskLeadAsLost: {
      type: Function as PropType<(lead: LeadSummary) => Promise<void>>,
      required: true,
    },
  },
  setup(props, {root}) {
    const dialog = ref(false)
    const selectedLead = ref<LeadSummary | null>(null)

    function viewLead(id: string) {
      root.$router.push({name: 'LeadDetail', params: {id}})
    }

    function createOffer(lead: LeadSummary) {
      root.$router.push({name: 'CreateOfferMotorbike', params: {leadId: lead.id}})
    }

    function openConfirmDialog(lead: LeadSummary) {
      dialog.value = true
      selectedLead.value = lead
    }

    function closeConfirmDialog() {
      dialog.value = false
      selectedLead.value = null
    }

    function confirmLostLead() {
      if (selectedLead.value) props.maskLeadAsLost(selectedLead.value)
      closeConfirmDialog()
    }

    return {
      LeadStatus,
      viewLead,
      createOffer,
      openConfirmDialog,
      closeConfirmDialog,
      confirmLostLead,
      dialog,
      selectedLead,
    }
  },
})
</script>
<style scoped></style>
